<template>
  <section class="news-guide-container">
    <div class="signal-logo">
      <svg xmlns="http://www.w3.org/2000/svg" width="122" height="38" viewBox="0 0 122 38">
        <g fill="none" fill-rule="evenodd">
          <path
            fill="#24C185"
            d="M1.517 6.47c1.34-.948 3.217-.658 4.19.648l14.695 19.706a2.875 2.875 0 0 1-.663 4.083c-1.34.95-3.217.66-4.19-.646L.853 10.554a2.875 2.875 0 0 1 .663-4.083zM9.607.744c1.34-.95 3.217-.66 4.19.646l5.29 7.095a2.875 2.875 0 0 1-.663 4.083c-1.34.949-3.216.66-4.19-.647l-5.29-7.094A2.875 2.875 0 0 1 9.607.744zM2.832 24.81c1.34-.948 3.216-.659 4.19.647l5.29 7.095a2.875 2.875 0 0 1-.664 4.083c-1.34.948-3.216.659-4.19-.647l-5.29-7.095a2.875 2.875 0 0 1 .664-4.083z"
          />
          <path
            :fill="isDarkMode ? 'white' : '#272C31'"
            d="M29.136 22.5c.523.51 1.204.973 2.044 1.391.84.419 1.764.628 2.772.628.243 0 .495-.023.756-.068.261-.046.495-.123.7-.232.205-.11.373-.255.504-.437.13-.182.196-.418.196-.71 0-.472-.247-.863-.742-1.172-.495-.31-1.218-.619-2.17-.928l-1.036-.327a12.188 12.188 0 0 1-1.75-.71 7.288 7.288 0 0 1-1.582-1.05 4.951 4.951 0 0 1-1.134-1.446c-.29-.555-.434-1.205-.434-1.95 0-.837.159-1.615.476-2.333a5.408 5.408 0 0 1 1.386-1.883c.607-.536 1.358-.955 2.254-1.255.896-.3 1.932-.45 3.108-.45.915 0 1.745.082 2.492.246.747.163 1.4.364 1.96.6s1.036.491 1.428.764c.392.273.69.518.896.736l-2.52 3.11a10.378 10.378 0 0 0-2.044-1.159c-.71-.3-1.437-.45-2.184-.45a3.31 3.31 0 0 0-.728.082 2.45 2.45 0 0 0-.658.245c-.196.11-.355.25-.476.423a1.088 1.088 0 0 0-.182.641c0 .273.07.51.21.71.14.2.331.373.574.518.243.146.537.277.882.396.345.118.714.24 1.106.368l.896.273c.635.2 1.279.432 1.932.695a6.378 6.378 0 0 1 1.764 1.064 5.3 5.3 0 0 1 1.288 1.665c.336.664.504 1.477.504 2.441 0 .837-.2 1.61-.602 2.32a5.887 5.887 0 0 1-1.624 1.827c-.681.51-1.484.905-2.408 1.187a10.07 10.07 0 0 1-2.954.423c-1.867 0-3.43-.241-4.69-.723-1.26-.482-2.329-1.132-3.206-1.95l2.996-3.52zm14.189-12.44h4.956v18.196h-4.956V10.06zm16.961 7.802h7.672v8.212a10.4 10.4 0 0 1-3.85 2.005c-1.447.41-2.898.614-4.354.614-1.512 0-2.87-.223-4.074-.668-1.204-.446-2.226-1.083-3.066-1.91-.84-.828-1.48-1.833-1.918-3.015-.439-1.182-.658-2.51-.658-3.983 0-1.382.238-2.66.714-3.833a8.882 8.882 0 0 1 2.002-3.029 9.139 9.139 0 0 1 3.066-1.977c1.185-.473 2.497-.71 3.934-.71 1.55 0 3 .25 4.354.75 1.353.5 2.487 1.333 3.402 2.497l-3.22 3.164a8.59 8.59 0 0 0-1.862-1.39c-.663-.365-1.433-.547-2.31-.547-.803 0-1.512.137-2.128.41a4.55 4.55 0 0 0-1.554 1.105 4.825 4.825 0 0 0-.966 1.637 5.92 5.92 0 0 0-.336 2.005c0 .782.121 1.487.364 2.114a4.765 4.765 0 0 0 1.008 1.61c.43.445.952.79 1.568 1.036.616.246 1.307.369 2.072.369.616 0 1.204-.073 1.764-.218.56-.146 1.101-.4 1.624-.764V21.6h-3.248v-3.738zm9.849-7.803h4.508l7.168 10.15v-10.15h4.9v18.197h-4.228l-7.448-10.449v10.45h-4.9V10.058zm24.521 0h5.684l6.608 18.197H101.6l-1.204-3.765h-6.244l-1.232 3.765h-5.124l6.86-18.197zm4.732 10.913l-2.072-6.684-2.156 6.684h4.228zm8.645-10.913h4.956V24h8.652v4.256h-13.608V10.06z"
          />
        </g>
      </svg>
    </div>
    <section class="news-guide-content">
      <section v-if="isGuidePage" class="section1 section-padding">
        <div class="news-guide-flex">
          <div style="flex: 1">
            <div class="news-guide-title">네이버앱 안에서 편리하게</div>
            <div class="mt10">
              시그널 실시간 검색어를 연결해보세요.<br />이제는 더 이상 볼 수 없는 실시간 검색어를 다시 만날 수 있습니다.
            </div>
          </div>
          <img loading="lazy" style="max-width: 344px; height: auto" src="../assets/img/news/news-image1.png" />
        </div>
        <div class="news-guide-flex flex-reverse mt50-0">
          <img loading="lazy" style="max-width: 470px; height: auto" src="../assets/img/news/news-image2.png" />
          <div style="flex: 1">
            <div class="news-guide-title">10초면, 설정 끝</div>
            <div class="mt10">네이버 앱과 단 한번의 연동으로 언제든지 실시간 검색어를 네이버앱 안에서 편하게 확인할 수 있습니다.</div>
          </div>
        </div>
        <div class="news-guide-flex">
          <div style="flex: 1">
            <div class="news-guide-title">세계 최고 AWS 보안</div>
            <div class="mt10">
              시그널의 모든 정보는 IT 기술의 강력한 보안 검증과 데이터 암호와로 엄격한 사이버 위기 관리지침으로 관리되고 있습니다.
            </div>
          </div>
          <img loading="lazy" style="max-width: 470px; height: auto" src="../assets/img/news/news-image9.png" />
        </div>
      </section>
      <section class="section2 section-padding" :style="isDarkMode ? 'background-color: #888888' : 'background-color:#f6f7f9'">
        <div class="section2-content">
          <div class="news-guide-title" style="text-align: center !important">네이버 앱에 실시간 검색어를<br />추가할 수 있어요!</div>
          <div class="news-guide-flex">
            <div style="position: relative; text-align: center">
              <img loading="lazy" src="../assets/img/news/news-image3.png" />
              <button class="direct-button" @click="$router.push('/')">signal.bz 바로가기</button>
            </div>

            <img loading="lazy" class="img-margin-left" src="../assets/img/news/news-image4.png" />
          </div>
          <div class="news-guide-flex">
            <img loading="lazy" src="../assets/img/news/news-image5.png" />
            <img loading="lazy" class="img-margin-left" src="../assets/img/news/news-image6.png" />
          </div>
          <div class="news-guide-title" style="text-align: center !important; margin-top: 100px">
            실시간 검색어 순서를 이동시켜 첫 화면에서 편하게 확인하세요.
          </div>
          <div class="news-guide-flex">
            <img loading="lazy" src="../assets/img/news/news-image7.png" />
            <img loading="lazy" class="img-margin-left" src="../assets/img/news/news-image8.png" />
          </div>
        </div>
      </section>
      <section v-if="isGuidePage" class="section3 section-padding">
        <div class="section3-content">
          <div class="news-guide-title" style="color: white">실시간 검색어를 다시 이용하는 사용자 리뷰</div>
          <div class="section3-flex mt30">
            <div class="section3-flex">
              <div>
                <img loading="lazy" style="display: block" src="../assets/img/news/news-image-review1.png" />
                <img loading="lazy" src="../assets/img/news/news-image-review2.png" />
              </div>
              <div>
                <img loading="lazy" src="../assets/img/news/news-image-review3.png" />
              </div>
            </div>
            <div class="section3-flex">
              <div>
                <img loading="lazy" style="display: block" src="../assets/img/news/news-image-review4.png" />
                <img loading="lazy" src="../assets/img/news/news-image-review5.png" />
              </div>
              <div>
                <img loading="lazy" style="display: block" src="../assets/img/news/news-image-review6.png" />
                <img loading="lazy" src="../assets/img/news/news-image-review7.png" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
    <Footer />
  </section>
</template>
<script>
import Footer from "../components/Footer"
import { mapGetters } from "vuex"
export default {
  components: { Footer },
  computed: {
    ...mapGetters({ isDarkMode: "isDarkMode" }),
    isGuidePage() {
      return this.$route.name === "guide"
    }
  }
}
</script>

<style lang="scss" scoped>
.mt50-0 {
  margin-top: 50px !important;
  @include desktop {
    margin-top: 0 !important;
  }
}
.signal-logo {
  max-width: 1440px;
  padding: 10px 15px;
  margin: auto;
}
.img-margin-left {
  @include desktop {
    margin-left: 40px;
  }
}
.direct-button {
  position: absolute;
  right: 10%;
  bottom: 15%;
  background: #24c185;
  border-radius: 4px;
  padding: 10px;
  color: white;

  @include tablet {
    right: 15%;
    bottom: 20%;
    padding: 10px 20px;
  }
}
.news-guide-container {
  overflow: scroll;
  .news-guide-title {
    font-weight: bold;
    font-size: 28px;
    text-align: center;
    letter-spacing: -1px;
    line-height: 1.1;
    max-width: 800px;
    margin: auto;
    @include desktop {
      font-size: 48px;
      text-align: left;
    }
  }

  .news-guide-content {
    .news-guide-flex {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 20px auto;
      @include desktop {
        flex-direction: row;
      }

      & img {
        width: 90%;
        @include tablet {
          width: 480px;
        }
      }

      & > :nth-child(n) {
        @include tablet {
          max-width: 480px;
        }
      }
      & > :nth-child(1) {
        margin-bottom: 20px;
        @include desktop {
          margin-bottom: 0;
        }
      }
    }
    .flex-reverse {
      flex-flow: column-reverse;
      @include desktop {
        flex-flow: row nowrap;
      }
    }
  }
  .section-padding {
    padding: 30px 20px;
    @include tablet {
      padding: 50px 20px;
    }
    @include desktop {
      padding: 80px 20px;
    }
  }
  .section1 {
    max-width: 800px;
    margin: 0 auto;
  }
  .section2 {
    .section2-content {
      width: 100%;
      max-width: 960px;
      margin: 0 auto;
    }
  }
  .section3 {
    background: #24c185;
    .section3-content {
      width: 100%;
      max-width: 1024px;
      margin: 0 auto;
      .section3-flex {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        @include tablet {
          flex-direction: row;
          flex-wrap: wrap;
          flex: 50%;
        }
        @include desktop {
          flex-direction: row;
          flex-wrap: nowrap;
        }
        & > :nth-child(n) {
          & > img {
            width: 290px;
          }
        }
      }
    }
  }
}
</style>
